// kontoPage/index.jsx
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import NavbarLogin from "scenes/widgets/navbarlogin";
import Footer from "scenes/widgets/footer";
import KontoForm from "./KontoForm";

const KontoPage = () => {
  const theme = useTheme();
  const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");
  return (
    <Box>
      <NavbarLogin />
      <Box
        width="100%"
        padding="2rem 6%"
        display="flex"
        justifyContent="center"
      >
        <Box
          width={isNonMobileScreens ? "50%" : "93%"}
          p="2rem"
          borderRadius="1.5rem"
          backgroundColor={theme.palette.background.alt}
        >
          <Typography
            fontWeight="500"
            variant="h5"
            sx={{ mb: "1.5rem", textAlign: "center" }}
          >
            Konto
          </Typography>
          <KontoForm />
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default KontoPage;
